// The brief's leading mark (Figma 13528:98508): the Symphony bento glyph — a black rounded-square tile
// carrying a 2×2 of white dots whose corners alternate square↔circle on the diagonal (the brand's
// agent=square / person=circle primitives).
//
// Every measurement is a fraction of `size` so it scales cleanly (Figma is drawn at 20): dot 4.341,
// gap 1.449, tile radius 6, and the square pair's radius 2.
export function BriefMark({ size = 20 }: { size?: number }) {
  const dot = size * 0.217;
  const gap = size * 0.0725;
  const round = size * 0.3; // > dot/2 → a full circle
  const square = size * 0.1;
  // Row-major: top-left square, top-right circle, bottom-left circle, bottom-right square.
  const radii = [square, round, round, square];
  return (
    <span
      aria-hidden
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: round,
        background: 'var(--ds-neutral-950)',
        display: 'inline-grid',
        gridTemplateColumns: `repeat(2, ${dot}px)`,
        gap,
        placeContent: 'center',
      }}
    >
      {radii.map((r, i) => (
        <span key={i} style={{ width: dot, height: dot, borderRadius: r, background: 'var(--ds-white)' }} />
      ))}
    </span>
  );
}
